import { render, staticRenderFns } from "./ArtistDetails.vue?vue&type=template&id=48aa0f03&"
import script from "./ArtistDetails.vue?vue&type=script&lang=js&"
export * from "./ArtistDetails.vue?vue&type=script&lang=js&"
import style0 from "./ArtistDetails.vue?vue&type=style&index=0&id=48aa0f03&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports